import { ArrowChevronDownMiniIcon, ArrowChevronUpMiniIcon } from '@calendly/ui/components/icons'
import { MinimalButton } from '@calendly/ui/components/minimal-button'

import { ButtonLabel } from './styles'

export const TextButton = ({ isOpen, onClick, children, loading, showChevron = true, disabled = false, ...props }) => (
  <MinimalButton
    loading={loading}
    onClick={onClick}
    disabled={disabled}
    {...props}
  >
    <ButtonLabel disabled={disabled}>
      {children}
      {showChevron && !isOpen && <ArrowChevronDownMiniIcon />}
      {showChevron && isOpen && <ArrowChevronUpMiniIcon />}
    </ButtonLabel>
  </MinimalButton>
)
